<app-navbar-primary />

<main class="bg-body-secondary">
  <div class="d-flex justify-content-center align-items-center h-100">
    <div class="card overflow-auto" style="width: 34rem; height: 34rem">
      <div class="card-body">
        <button class="btn p-0 mb-3" routerLink="/">
          <img src="/assets/icons/arrow_left_short.svg" alt="" />
          <span class="text-body-secondary">Volver</span>
        </button>

        <h4>Comités</h4>

        <div class="list-group mt-4">
          @if (loading) {
            <div class="text-center py-3">
              <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
            </div>
          } @else if (error) {
            <div class="text-body-secondary py-2">
              No se pudieron cargar los documentos. Intenta más tarde.
            </div>
          }
          @for (committee of committees; track committee.id) {
            <a
              class="list-group-item list-group-item-action"
              [href]="committee.url"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ committee.name }}
            </a>
          }
        </div>
      </div>
    </div>
  </div>
</main>

<app-footer-primary />
